import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-7 md:py-10 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-91">
      <div className="max-w-2xl mx-auto text-center" data-id="element-92">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-accent rounded-full mb-5 shadow-[0_0_30px_rgba(34,197,94,0.6)]" data-id="element-93">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-brand-dark" data-id="element-94" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-5 text-brand-accent neon-glow uppercase tracking-tight" data-id="element-95">
          🛡️ Garantía de Satisfacción Total
        </h2>

        <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-5 md:p-6 text-left space-y-3" data-id="element-96">
          <p className="text-sm md:text-base text-white font-bold leading-relaxed" data-id="element-97">
            <span className="text-brand-accent font-black" data-id="element-98">
              Probalo 7 días.
            </span>{' '}
            Usá el material en tu clase más difícil. Si no cumple tus
            expectativas, te devolvemos el{' '}
            <span className="text-brand-accent font-black" data-id="element-99">
              100% de tu dinero
            </span>
            .
          </p>
          <p className="text-xs md:text-sm text-gray-400 font-black uppercase tracking-widest pt-2 border-t border-white/10" data-id="element-100">
            Sin preguntas. Sin formularios. Sin dramas.
          </p>
        </div>
      </div>
    </section>;
}